import { useEffect, useMemo, useState } from "react";
import { fetchEvents } from "@/lib/api";
import EventCard from "@/components/rotta/EventCard";
import { StateFilter } from "@/components/rotta/StateFilter";
import { matchesState } from "@/lib/brStates";

export default function Eventos() {
  const [events, setEvents] = useState([]);
  const [uf, setUf] = useState("all");
  useEffect(() => { fetchEvents().then(setEvents).catch(() => {}); }, []);

  const filtered = useMemo(() => events.filter((e) => matchesState(e.state, uf)), [events, uf]);

  return (
    <div data-testid="eventos-page" className="pt-32 pb-24">
      <div className="container-rotta">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[#C6A762] mb-5">
            <span className="gold-divider" />
            <span className="text-[11px] tracking-[0.35em] uppercase">Agenda 2026</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-white leading-[1.0]">
            Encontros que <span className="text-gold-gradient">valem a viagem.</span>
          </h1>
          <p className="text-[#B8B8B8] mt-5 leading-relaxed">
            Curadoria dos principais eventos de motociclismo no Brasil. De encontros estradeiros
            a feiras e festivais.
          </p>
        </div>

        <div className="mt-12 flex justify-start sm:justify-end">
          <StateFilter value={uf} onChange={setUf} testId="eventos-state-filter" />
        </div>

        <div className="mt-8 grid gap-7 lg:grid-cols-2">
          {filtered.map((e) => <EventCard key={e.slug} event={e} />)}
        </div>

        {filtered.length === 0 && (
          <p data-testid="eventos-empty-state" className="text-[#B8B8B8] text-center py-16">
            Nenhum evento encontrado para este estado.
          </p>
        )}
      </div>
    </div>
  );
}
